import { getAuthHeaders, getTokenSubscriptionStatus, urlMap } from '../utils';

const PRO_STATUSES = new Set(['active', 'trialing']);

export function isProFromPrefs(userPreferences) {
  const prefs = userPreferences && typeof userPreferences === 'object' ? userPreferences : {};
  const plan = String(prefs.plan || 'free').toLowerCase();
  const planStatus = String(prefs.planStatus || 'inactive').toLowerCase();
  return plan === 'premium' && PRO_STATUSES.has(planStatus);
}

export async function fetchSubscriptionStatus() {
  const tokenSnapshot = getTokenSubscriptionStatus();

  try {
    const res = await fetch(urlMap.walletSubscriptionStatus, {
      headers: getAuthHeaders(),
      credentials: 'include',
    });
    const body = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(body?.error || `HTTP_${res.status}`);
    return {
      isPro: !!body.isPro,
      plan: body.plan || 'free',
      planStatus: body.planStatus || 'inactive',
    };
  } catch {
    if (tokenSnapshot) return tokenSnapshot;
    return { isPro: false, plan: 'free', planStatus: 'unknown' };
  }
}

export function openSubscriptionTabInWallet() {
  window.dispatchEvent(new CustomEvent('storyclub:open-wallet-subscription'));
}
